import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../config/config';
@Injectable({
  providedIn: 'root'
})
export class ConceptoService {

  dataUrl = Config.URL_BASE;

  constructor(
    private http: HttpClient
  ) { }

  catalogo(criterio: PageBusquedaObject): Observable<any> {
    let url_ = this.dataUrl + '/ctbcon/catalogo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  post(dto: Ctbcon): Observable<any> {
    let url_ = this.dataUrl + '/ctbcon/post';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  delete(id: number, idUsr: number): Observable<any> {
    const url_ = this.dataUrl + '/ctbcon/delete/' + id + '/' + idUsr;
    return this.http.delete(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  put(dto: Ctbcon): Observable<any> {
    let url_ = this.dataUrl + '/ctbcon/put';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getConcepto(id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbcon/get/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }


}

export class Ctbcon {
  id: number;
  codigo: String;
  titulo: String;
  gral_emp_id: number;
  momento_crea: String;
  momento_actualiza: String;
  momento_baja: String;
  gralUsrCreaId: number;
  gralUsrActualizaId: number;
  gralUsrBajaId: number;
}

export class PageBusquedaObject {
  column?: string | undefined;
  criteriaSearch?: any | undefined;
  itemsPerPage?: number | undefined;
  order?: string | undefined;
  pageNumber?: number | undefined;
  sort?: boolean | undefined;
}
